module.exports = __webpack_public_path__ + "img/40.59ff519b.png";